var scaleX;
var scaleY;
var canvasW;
var canvasH;
var dely;


function resize() {
	console.log("resize", window.innerWidth, window.innerHeight);
	//alert("resize"+window.innerWidth+":"+window.innerHeight)
	var pingTai = navigator.platform;
	heights = 1650

	//手机平台
	if (window.innerHeight > window.innerWidth) {
		scaleX = window.innerWidth / 750;
		scaleY = scaleX; //等比显示,注释后是不等比显示
	} else {
		scaleX = window.innerWidth / 750;
		scaleY = scaleX;
	}

	//横屏提示
	var windowW = window.innerWidth;
	var windowH = window.innerHeight;
	windowW = window.innerWidth
	windowH = heights * scaleY
	var sss = window.innerHeight / scaleY / heights
	$("#canvas").css("width", window.innerWidth);
	$("#canvas").css("height", heights * scaleY); //高度压缩或拉伸
	canvasW = windowW;
	canvasH = windowH;

	 dely = 0

}

var canvas, stage, exportRoot;
var tweenTime = 800; //
var cut = 0;
var pages;
var perMc;
var loader;
var canvasX = 0;
var stage;
var ticker;
var perTxt;
var loadingchangchengl;
var bgColor = "#FFAB18"; //加载时的背景色
var dotColor = "#FFFFFF"; //加载时圆点的颜色
var stageW = 750;
var stageH = 1180;
var dotNum = 12; //进度点个数
var banJing = 50; //进度半径
var loadDotArr = [];
var isiOS;
var lib;
var isAndroid;
var load2;
var imgUrl;
var picliader;
var screenFix = true //
var kadingmov;
var drawTimeout = 0;
var __mask;
__mask = new createjs.Shape();
__mask.graphics.beginFill("#ff0").drawCircle(0, 0, 1).closePath();
var drawProgress;
var waitTime = 2000; //绘制自动完成的时间




var anim_container, dom_overlay_container, fnStartAnimation;

export function init() {
	canvas = document.getElementById("canvas");
	anim_container = document.getElementById("animation_container");
	dom_overlay_container = document.getElementById("dom_overlay_container");
	var comp = AdobeAn.getComposition("71C74B80D71C3A47A935D191DF6E7537");
	lib = comp.getLibrary();
	var loader = new createjs.LoadQueue(false);
	loader.addEventListener("fileload", function(evt) {
		handleFileLoad(evt, comp)
	});
	loader.addEventListener("complete", function(evt) {
		handleComplete(evt, comp)
	});
	lib = comp.getLibrary();
	loader.loadManifest(lib.properties.manifest);
}

function handleFileLoad(evt, comp) {
	var images = comp.getImages();
	if (evt && (evt.item.type == "image")) {
		images[evt.item.id] = evt.result;
	}
}

function handleComplete(evt, comp) {
	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
	var lib = comp.getLibrary();
	var ss = comp.getSpriteSheet();
	var queue = evt.target;
	var ssMetadata = lib.ssMetadata;
	for (var i = 0; i < ssMetadata.length; i++) {
		ss[ssMetadata[i].name] = new createjs.SpriteSheet({
			"images": [queue.getResult(ssMetadata[i].name)],
			"frames": ssMetadata[i].frames
		})
	}
	exportRoot = new lib.index();
	stage = new lib.Stage(canvas);
	//Registers the "tick" event listener.
	fnStartAnimation = function() {
		resize()
		initstutas();
		stage.addChild(exportRoot);
		createjs.Ticker.framerate = lib.properties.fps;
		createjs.Ticker.addEventListener("tick", stage);
	}
	//Code to support hidpi screens and responsive scaling.
	AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container, dom_overlay_container]);
	AdobeAn.compositionLoaded(lib.properties.id);
	fnStartAnimation();
}
var scaleX;
var scaleY;
var canvasW;
var canvasH;
var heights = 1624;



var jishu = 0;
var jishu2 = 0
var stage2, exportRoot2;
var iswx = 0;

function sodg() {
	var ua = navigator.userAgent.toLowerCase();
	var isWeixin = ua.indexOf('micromessenger') != -1;
}

function playSound(id, loop) {
	return createjs.Sound.play(id, createjs.Sound.INTERRUPT_EARLY, 0, 0, loop);
}


var inity = 0;

function pagedown() {
	createjs.Tween.get(exportRoot.instance_1).to({
		y: -100
	}, 2000, createjs.Ease.quadOut);
}

function GenNonDuplicateID(randomLength) {
	return Number(Math.random().toString().substr(3, randomLength) + Date.now()).toString(36)
}
var nx = 3,
	ny = 4;
var count;
var cellArray = [];
var selectedCell = null;
export function initstutas() {

	var sscle = window.innerWidth / 750;
	var isbaoseng = 0
	var ismaseng = 0
	exportRoot.ggm.instance_4.x = 130;
	exportRoot.ggm.instance_4.y = 280;
	exportRoot.ggm.instance_4.scaleX = exportRoot.ggm.instance_4.scaleY = 1.3;
	gamesk()
	gamest();
	// exportRoot.page2.instance_1.addEventListener('click', gamephb);
	// exportRoot.instance_1.instance.addEventListener('click', backgamephb);
	// exportRoot.ggm.chakan.addEventListener('click', gamephb);
	// exportRoot.ggm.instance.instance.addEventListener('click',gametart );
	// exportRoot.ggm.instance.instance_1.addEventListener('click', gamestc); 
	//   exportRoot.ggm.chakan.visible=false;
	exportRoot.ggm.visible = true;
	//  exportRoot.ggm.instance.alpha=0;
	//  exportRoot.ggm.instance_1.visible=false;

	//  exportRoot.ggm.instance_1.instance.addEventListener('click', gamehome);
	//  exportRoot.ggm.instance_1.instance_1.addEventListener('click',gameastc );


}



function gamehome() {



	createjs.Sound.play("dianji");
	time1 = 0;
	time2 = 0;
	time3 = 0;
	exportRoot.ggm.visible = false;
	exportRoot.instance_1.visible = false;
	exportRoot.home.visible = true;
	exportRoot.home.gotoAndPlay(0)
}

function gamest() {
	createjs.Sound.play("dianji");
	canvas.removeEventListener("touchmove", ddm);
	canvas.removeEventListener("touchstart", ddw);
	canvas.removeEventListener("touchend", ddu)

	// 重置游戏结束标志
	isGameEnded = false;
	
	initg(nx, ny);
	reset();
	Rseset();
	start()
	resize()
	//     exportRoot.ggm.chakan.visible=false;
	//  exportRoot.ggm.instance.visible=false;
	//  exportRoot.ggm.instance.alpha=0;
	//  exportRoot.ggm.instance_1.visible=false;
	//  exportRoot.ggm.instance_3.visible=true;
	createjs.Tween.get(exportRoot.ggm.instance_4).to({
		alpha: 100
	}, 1000, createjs.Ease.quadOut).call(timetart);
}

function gameastc() {
	createjs.Sound.play("dianji");
	
	// 重置游戏结束标志
	isGameEnded = false;

	initg3(nx, ny);
	reset();
	createjs.Tween.get(exportRoot.ggm.instance_4).to({
		alpha: 100
	}, 1000, createjs.Ease.quadOut).call(timetart);


}

function gamestc() {
	createjs.Sound.play("dianji");
	// 重置游戏结束标志
	isGameEnded = false;
	
	exportRoot.ggm.instance_1.visible = false;
	exportRoot.ggm.instance_1.alpha = 0;
	if (guanshu == 1) {
		exportRoot.ggm.instance.alpha = 0;
		exportRoot.ggm.instance.visible = false;
		initg(nx, ny);
		reset();
		Rseset();
		start()
		createjs.Tween.get(exportRoot.ggm.instance_3).to({
			alpha: 100
		}, 1000, createjs.Ease.quadOut).call(timetart);
	} else if (guanshu == 2) {
		initg2(nx, ny);
		reset();
		createjs.Tween.get(exportRoot.ggm.instance_3).to({
			alpha: 100
		}, 1000, createjs.Ease.quadOut).call(timetart);
		exportRoot.ggm.instance.alpha = 0;
		exportRoot.ggm.instance.visible = false;
	} else if (guanshu == 3) {
		initg3(nx, ny);
		reset();
		createjs.Tween.get(exportRoot.ggm.instance_3).to({
			alpha: 100
		}, 1000, createjs.Ease.quadOut).call(timetart);
		exportRoot.ggm.instance.alpha = 0;
		exportRoot.ggm.instance.visible = false;
	}
}

function gametart() {
	createjs.Sound.play("dianji");
	// 重置游戏结束标志
	isGameEnded = false;
	
	console.log("122223311111", guanshu)
	if (guanshu == 1) {
		initg2(nx, ny);
		reset();
		createjs.Tween.get(exportRoot.ggm.instance_3).to({
			alpha: 100
		}, 1000, createjs.Ease.quadOut).call(timetart);
		exportRoot.ggm.instance.alpha = 0;
		exportRoot.ggm.instance.visible = false;
	} else if (guanshu == 2) {
		initg3(nx, ny);
		reset();
		createjs.Tween.get(exportRoot.ggm.instance_3).to({
			alpha: 100
		}, 1000, createjs.Ease.quadOut).call(timetart);
		exportRoot.ggm.instance.alpha = 0;
		exportRoot.ggm.instance.visible = false;
		// guanshu=4
	} else if (guanshu == 3) {
		exportRoot.ggm.chakan.visible = true;
		exportRoot.ggm.instance.alpha = 0;
		exportRoot.ggm.instance.visible = false;
		submitdate();
	}
}

function hidea1() {
	exportRoot.ggm.instance.visible = false;
}

function timetart() {
	// 重置游戏结束标志
	isGameEnded = false;
	Rseset();
	start();
}

function submitdate() {
	//   $.ajax({ 
	//           url:"https://js.loten.com.cn/ad/llk/setcard.php",

	//           data:{uid:openid,score:parseFloat(time1)+parseFloat(time2)+parseFloat(time3),name:openname,head:head}, 
	//           type:'POST', 
	//           success: function(data){ 
	//             console.log("成功",data)


	//           },error:function(data){
	//             if(data["readyState"]!=4)
	//             {
	//               alert("上传失败！")

	//             }
	//             console.log(data["readyState"]);
	//           //  alert("上传失败！")
	//       } 
	//  });
}

function onend() {

	exportRoot.ggm.instance.visible = true;
	exportRoot.ggm.instance.alpha = 0
	exportRoot.ggm.instance.biaoti.gotoAndStop(guanshu - 1)
	createjs.Tween.get(exportRoot.ggm.instance).to({
		alpha: 100
	}, 1000, createjs.Ease.quadOut) //
}
var time1 = 0;
var time2 = 0;
var time3 = 0;

function chongkaishi() {
	// 设置游戏结束标志，防止继续点击
	isGameEnded = true;
	
	// 格式化时间：millisecond是0-990，需要除以10得到0-99
	var ms = Math.floor(millisecond / 10);
	time1 = second + "." + (ms < 10 ? "0" + ms : ms);
	
	// 使用CustomEvent而不是Event，以便传递data
	var evt = new CustomEvent('endGame', {
		detail: {
			time: time1,
		}
	});
	
	// 确保canvas存在后再触发事件
	if (canvas) {
		canvas.dispatchEvent(evt);
		console.log("游戏结束，时间:", time1);
	} else {
		console.error("canvas元素不存在，无法触发endGame事件");
	}

	//initstutas();
}

function gamephb() {
	createjs.Sound.play("dianji");
	canvas.removeEventListener("touchmove", ddm);
	canvas.removeEventListener("touchstart", ddw);
	canvas.removeEventListener("touchend", ddu)
	$.ajax({
		url: "https://js.loten.com.cn/ad/llk/getcard.php",
		async: false,
		data: {
			uid: openid
		},
		type: 'POST',
		dataType: 'JSON',
		success: function(data) {
			if (data.mesocre) {
				exportRoot.instance_1.text.text = parseInt(data.me.count) + 1
				exportRoot.instance_1.ime.text.text = data.mesocre.score + "秒";;
				exportRoot.instance_1.ime.text_1.text = openname;
				exportRoot.instance_1.ime.ronq.visible = true;
			}
			var ll = data.list.length
			if (data.list.length > 7) {
				ll = 7
			}

			for (var i = 0; i < ll; i++) {
				exportRoot.instance_1["im" + i].text.text = data.list[i].score + "秒";
				exportRoot.instance_1["im" + i].text_1.text = data.list[i].name;
				exportRoot.instance_1["im" + i].ronq.visible = true;
				var imgs = new Image();

				console.log("ccca" + i);
				if (imgs.complete) {
					console.log("222a" + i);
					var scaleX = 61 / 132;
					var scaleY = 61 / 132;
					var bitmap = new createjs.Bitmap(imgs);
					bitmap.scaleX = scaleX
					bitmap.scaleY = scaleY

					exportRoot.instance_1["im" + i].ronq.addChild(bitmap);

				} else {
					imgs.onload = function(event) {
						console.log("222b" + i);
						scaleX = 61 / 132;
						scaleY = 61 / 132;
						imgs.onload = null;
						var bitmap = new createjs.Bitmap(imgs);
						bitmap.scaleX = scaleX
						bitmap.scaleY = scaleY

						exportRoot.instance_1["im" + i].ronq.addChild(bitmap);


					};
				};

				imgs.src = data.list[i].head.replace('http', 'https');;
			}
		}
	});


	exportRoot.instance_1.visible = true;
	exportRoot.page2.visible = false;
	exportRoot.ggm.visible = false;
}

function backgamephb() {
	createjs.Sound.play("dianji");
	exportRoot.instance_1.visible = false;

	exportRoot.home.visible = true;
	exportRoot.home.gotoAndPlay(0)
}


var yzuod = 32

function gamesk() {
	createjs.Sound.play("dianji");
	canvas.addEventListener("touchmove", ddm);
	canvas.addEventListener("touchstart", ddw);
	canvas.addEventListener("touchend", ddu)


}

function ddm(event) {
	console.log(exportRoot.page2.instance_4.instance.y + (event.changedTouches[0].clientY - cx) * 1.5)

	if (exportRoot.page2.instance_4.instance.y + (event.changedTouches[0].clientY - cx) * 1.5 < -183 && exportRoot.page2
		.instance_4.instance.y + (event.changedTouches[0].clientY - cx) * 1.5 > -663)
		exportRoot.page2.instance_4.instance.y += (event.changedTouches[0].clientY - cx) * 1.5;


	cx = event.changedTouches[0].clientY;


}
var biabnhua = []

function initg(m, n) {
	guanshu = 1;
	var tmp = [];
	cellArray = [];
	totaltimes = totaltimes0
	// exportRoot.ggm.instance_2.gotoAndStop(0)
	biabnhua = []
	for (var i = 0; i < n + 2; i++) {
		//var row = document.createElement('div');
		//row.setAttribute('class', 'row');
		var cellArrayRow = [];
		cellArray.push(cellArrayRow);
		//gameDiv.appendChild(row);

		for (var j = 0; j < m + 2; j++) {
			var cell = new lib.skin();
			cellArrayRow.push(cell);
			//  if(i==0||j==0||i==n+1||j==m+1 ||j==3||j==4||i==7||i==3){
			//     cell.gotoAndStop(10)
			// }else{
			biabnhua.push(cell)

			// }

			cell.id = j + '_gc_' + i;
			cell.xx = j;
			cell.yy = i
			cell.x = j * 100 - 420;
			cell.y = i * 100 - 610
			cell.lk.visible = false;

			// console.log(cell.xx,cell.yy)
			exportRoot.ggm.instance_4.addChild(cell);



		}
	}
	count = biabnhua.length;
	for (i = 0; i < biabnhua.length / 2; i++) {
		var c = symbols.charAt(Math.floor(Math.random() * symbols.length));
		tmp.push(c);
		tmp.push(c);
	}
	for (i = biabnhua.length - 1; i >= 0; i--) {
		var r = Math.floor(Math.random() * i);
		// console.log(tmp,r)
		c = tmp.splice(r, 1);

		biabnhua[i].gotoAndStop(c)
		biabnhua[i].addEventListener('click', onCellClicked);
	}
}


function initg2(m, n) {
	var tmp = [];
	cellArray = [];
	guanshu = 2;
	biabnhua = []
	totaltimes = totaltimes1
	exportRoot.ggm.instance_2.gotoAndStop(0)
	for (var i = 0; i < n + 2; i++) {
		//var row = document.createElement('div');
		//row.setAttribute('class', 'row');
		var cellArrayRow = [];
		cellArray.push(cellArrayRow);
		//gameDiv.appendChild(row);

		for (var j = 0; j < m + 2; j++) {
			var cell = new lib.skin();
			cellArrayRow.push(cell);

			if (i == 0 || j == 0 || i == n + 1 || j == m + 1 || i == 7 || i == 3) {
				cell.gotoAndStop(10)

			} else {
				biabnhua.push(cell)



			}

			cell.id = j + '_gc_' + i;
			cell.xx = j;
			cell.yy = i
			cell.x = j * 100 - 420;
			cell.y = i * 100 - 610
			cell.lk.visible = false;

			// console.log(cell.xx,cell.yy)
			exportRoot.ggm.instance_3.addChild(cell);



		}
	}
	count = biabnhua.length;
	for (i = 0; i < biabnhua.length / 2; i++) {
		var c = symbols.charAt(Math.floor(Math.random() * symbols.length));
		tmp.push(c);
		tmp.push(c);
	}
	for (i = biabnhua.length - 1; i >= 0; i--) {
		var r = Math.floor(Math.random() * i);
		// console.log(tmp,r)
		c = tmp.splice(r, 1);

		biabnhua[i].gotoAndStop(c)
		biabnhua[i].addEventListener('click', onCellClicked);
	}
}


function initg3(m, n) {
	var tmp = [];
	biabnhua = []
	guanshu = 3;
	totaltimes = totaltimes2
	exportRoot.ggm.instance_2.gotoAndStop(0)
	cellArray = [];
	for (var i = 0; i < n + 2; i++) {
		var cellArrayRow = [];
		cellArray.push(cellArrayRow);

		for (var j = 0; j < m + 2; j++) {
			var cell = new lib.skin();
			cellArrayRow.push(cell);
			if (i == 0 || j == 0 || i == n + 1 || j == m + 1) {
				cell.gotoAndStop(10)

			} else {
				biabnhua.push(cell)



			}

			cell.id = j + '_gc_' + i;
			cell.xx = j;
			cell.yy = i
			cell.x = j * 100 - 420;
			cell.y = i * 100 - 610
			cell.lk.visible = false;

			// console.log(cell.xx,cell.yy)
			exportRoot.ggm.instance_3.addChild(cell);



		}
	}
	count = biabnhua.length;
	for (i = 0; i < biabnhua.length / 2; i++) {
		var c = symbols.charAt(Math.floor(Math.random() * symbols.length));
		tmp.push(c);
		tmp.push(c);
	}
	for (i = biabnhua.length - 1; i >= 0; i--) {
		var r = Math.floor(Math.random() * i);
		// console.log(tmp,r)
		c = tmp.splice(r, 1);

		biabnhua[i].gotoAndStop(c)
		biabnhua[i].addEventListener('click', onCellClicked);
	}
}

function reset() {


}

function onCellClicked(e) {
	// 如果游戏已结束，禁止继续点击
	if (isGameEnded) {
		return;
	}
	
	if (e.currentTarget.currentFrame == 6) {
		return;
	}
	if (selectedCell) {
		tryMatch(selectedCell, e.currentTarget);
		selectedCell.alpha = 1
		selectedCell = null;
	} else {
		selectedCell = e.currentTarget;
		//selectedCell 选择状态
		selectedCell.alpha = 0.5
		//selectedCell.setAttribute('class', 'cell selected');
	}
}
var symbols = '012345';

function fc(x, y) {
	if (x < 0 || x > nx + 1 || y < 0 || y > ny + 1) {
		return null;
	}
	return cellArray[y][x];
}

function tryMatch(ca, cb) {
	if (ca == cb) {
		createjs.Sound.play("shibai");
		return;
	}

	if (ca.currentFrame != cb.currentFrame) {
		createjs.Sound.play("shibai");
		return;
	}

	var pathStack = [ca];
	var found = false;
	var nexts = neibors(ca);
	for (var i = 0; i < nexts.length; i++) {
		if (findPath(nexts[i], cb, pathStack, 0)) {
			found = true;
			break;
		}
	}
	if (!found) {
		createjs.Sound.play("shibai");
		return;
	}

	ca.currentFrame = cb.currentFrame = 10;
	setTimeout(drawPath, 10, pathStack);
	count -= 2;
	console.log("剩余卡片数:", count)
	if (count < 2) {
		// 停止计时器
		window.clearInterval(int);
		console.log("游戏完成，准备结束")
		// 延迟调用chongkaishi，确保drawPath动画完成
		// 等待路径绘制动画完成（150ms）后再触发结束事件
		setTimeout(function() {
			chongkaishi();
		}, 200);
	}
}

var guanshu = 0;
var isGameEnded = false; // 游戏是否已结束标志


/////////////////成功画线
function drawPath(path) {
	createjs.Sound.play("xiaochu");
	for (var i = 0; i < path.length; i++) {
		path[i].lk.visible = true;

		if (i < path.length - 1 && i != 0) {
			if (path[i].xx > path[i + 1].xx && path[i].yy == path[i + 1].yy && path[i].yy == path[i - 1].yy) {
				path[i].lk.gotoAndStop(1)
			}
			if (path[i].xx < path[i + 1].xx && path[i].yy == path[i + 1].yy && path[i].yy == path[i - 1].yy) {
				path[i].lk.gotoAndStop(1)
			}
			if (path[i].yy > path[i + 1].yy && path[i].xx == path[i + 1].xx && path[i].xx == path[i - 1].xx) {
				path[i].lk.gotoAndStop(0)
			}
			if (path[i].yy < path[i + 1].yy && path[i].xx == path[i + 1].xx && path[i].xx == path[i - 1].xx) {
				path[i].lk.gotoAndStop(0)
			}

			if (path[i].xx > path[i - 1].xx && path[i].yy > path[i + 1].yy && path[i].yy == path[i - 1].yy) {
				path[i].lk.gotoAndStop(2)
			}
			if (path[i].xx > path[i - 1].xx && path[i].yy < path[i + 1].yy && path[i].yy == path[i - 1].yy) {
				path[i].lk.gotoAndStop(4)
			}
			if (path[i].xx < path[i - 1].xx && path[i].yy > path[i + 1].yy && path[i].yy == path[i - 1].yy) {
				path[i].lk.gotoAndStop(3)
			}
			if (path[i].xx < path[i - 1].xx && path[i].yy < path[i + 1].yy && path[i].yy == path[i - 1].yy) {
				path[i].lk.gotoAndStop(5)
			}

			if (path[i].yy > path[i - 1].yy && path[i].xx > path[i + 1].xx && path[i].xx == path[i - 1].xx) {
				path[i].lk.gotoAndStop(2)
			}
			if (path[i].yy > path[i - 1].yy && path[i].xx < path[i + 1].xx && path[i].xx == path[i - 1].xx) {
				path[i].lk.gotoAndStop(3)
			}
			if (path[i].yy < path[i - 1].yy && path[i].xx > path[i + 1].xx && path[i].xx == path[i - 1].xx) {
				path[i].lk.gotoAndStop(4)
			}
			if (path[i].yy < path[i - 1].yy && path[i].xx < path[i + 1].xx && path[i].xx == path[i - 1].xx) {
				path[i].lk.gotoAndStop(5)
			}
		} else if (i == path.length - 1) {
			if (path[i].xx > path[i - 1].xx) {
				path[i].lk.gotoAndStop(7)
			} else if (path[i].xx < path[i - 1].xx) {
				path[i].lk.gotoAndStop(6)
			}
			if (path[i].yy > path[i - 1].yy) {
				path[i].lk.gotoAndStop(8)
			} else if (path[i].yy < path[i - 1].yy) {
				path[i].lk.gotoAndStop(9)
			}
		} else if (i == 0) {
			if (path[i].xx > path[i + 1].xx) {
				path[i].lk.gotoAndStop(7)
			} else if (path[i].xx < path[i + 1].xx) {
				path[i].lk.gotoAndStop(6)
			}
			if (path[i].yy > path[i + 1].yy) {
				path[i].lk.gotoAndStop(8)
			} else if (path[i].yy < path[i + 1].yy) {
				path[i].lk.gotoAndStop(9)
			}
		}

		// console.log(path[i].xx,path[i].yy)
	}
	setTimeout(clearPath, 150, path);
}

function clearPath(path) {
	for (var i = 0; i < path.length; i++) {
		path[i].lk.visible = false;
		path[i].gotoAndStop(10)

	}
}


function findPath(c, target, pathStack, trunCount) {
	if (!c) {
		return false;
	}
	var c_2 = pathStack[pathStack.length - 2];
	if (c_2 && c_2.xx != c.xx && c_2.yy != c.yy) {
		if (++trunCount > 2) {
			return false;
		}
	}
	if (c == target) {
		pathStack.push(c);
		return true;
	}
	if (c.currentFrame != 10) {
		return false;
	}
	if (pathStack.indexOf(c) >= 0) {
		return false;
	}
	pathStack.push(c);

	var nexts = neibors(c);
	for (var i = 0; i < nexts.length; i++) {
		if (findPath(nexts[i], target, pathStack, trunCount)) {
			return true;
		}
	}
	pathStack.pop();
	return false;
}

function neibors(c) {
	var neiborArr = [
		fc(c.xx - 1, c.yy),
		fc(c.xx + 1, c.yy),
		fc(c.xx, c.yy + 1),
		fc(c.xx, c.yy - 1)
	];
	return neiborArr;
}
var totaltimes = 30;
var totaltimes0 = 30;
var totaltimes1 = 35;
var totaltimes2 = 40;

//初始化变量
var hour, minute, second; //时 分 秒
hour = minute = second = 0; //初始化
var millisecond = 0; //毫秒
var int;
//重置函数
function Rseset() {
	window.clearInterval(int);
	millisecond = hour = minute = second = 0;
}
//开始函数
function start() {
	int = setInterval(timer, 10); //每隔50毫秒执行一次timer函数
}
//计时函数
function timer() {
	millisecond = millisecond + 10;
	if (millisecond >= 1000) {
		millisecond = 0;
		second = second + 1;
	}
	if (second >= 60) {
		// second=0;
		//  minute=minute+1;
	}

	if (minute >= 60) {
		//  minute=0;
		// hour=hour+1;
	}
	if (millisecond / 10 < 10) {
		exportRoot.ggm.text.text = second + "." + "0" + millisecond / 10
	} else {
		exportRoot.ggm.text.text = second + "." + millisecond / 10
	}
	//  console.log(millisecond)


}

function shibaifun() {
	stop()
	for (var i = 0; i < biabnhua.length; i++) {
		biabnhua[i].gotoAndStop(10)
	}


	createjs.Tween.get(exportRoot.ggm.instance_3).to({
		alpha: 0
	}, 1000, createjs.Ease.quadOut).call(osd);

}

function osd() {
	exportRoot.ggm.instance_1.visible = true;
	exportRoot.ggm.instance_1.alpha = 0
	exportRoot.ggm.instance_1.biaoti.gotoAndStop(guanshu - 1)
	createjs.Tween.get(exportRoot.ggm.instance_1).to({
		alpha: 100
	}, 1000, createjs.Ease.quadOut) //
}

var cy = 0;
var cx = 0;
var nnm = 0;

function ddw(event) {

	cx = event.changedTouches[0].clientY;
}

function ddu(event) {

}


//////////////////
// WEBPACK FOOTER
// ./static/js/libs/umcommaan.js
// module id = null
// module chunks = 